import * as React from 'react';
import { IDialogContext } from './models';

export const DialogContext = React.createContext<IDialogContext>({
  open: false,
  onClose: () => {},
  id: 'DialogContainer',
});
